"use client";

import { RiCheckLine } from "react-icons/ri";

import { cx } from "@/lib/tailwind-utils";

export function CheckCircle({
  checked,
  celebrating = false,
  onToggle,
  disabled,
  label,
  className,
}: {
  checked: boolean;
  /** Plays the completion burst. */
  celebrating?: boolean;
  onToggle?: () => void;
  disabled?: boolean;
  /** Accessible name, e.g. "Mark Upload your logo done". */
  label: string;
  className?: string;
}) {
  const interactive = Boolean(onToggle) && !disabled;

  const body = (
    <span
      className={cx(
        "flex size-4 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 motion-reduce:transition-none",
        checked
          ? "border-foreground bg-foreground text-background"
          : "border-border text-transparent",
        interactive && !checked && "group-hover/check:border-foreground",
        celebrating &&
          "motion-preset-confetti border-status-success-text bg-status-success-bg text-status-success-text !scale-125",
      )}
    >
      <RiCheckLine className="size-2.5" aria-hidden="true" />
    </span>
  );

  if (!interactive) {
    return (
      <span className={cx("inline-flex", className)} aria-hidden="true">
        {body}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={checked}
      className={cx(
        "group/check -m-2 inline-flex size-8 items-center justify-center rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
        className,
      )}
    >
      {body}
    </button>
  );
}
